<cf2-table
    [dataSub]="data$ | async"
    [columnConfig]="columnConfig"
    sortColumn="scheduledStartDateFormatted"
    (selected)="viewOutcome($event)"
></cf2-table>